/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";

class BreadCrums extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      CrumsList: [],
    };
  }
  componentDidMount() {
    this.crumListstateUpdate();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.crumListstateUpdate();
    }
  }

  crumListstateUpdate() {
    this.setState((state, props) => ({
      CrumsList: this.props.location.pathname.split("/"),
    }));
  }

  creumList() {
    return (
      this.state.CrumsList
        // eslint-disable-next-line array-callback-return
        .map((value, i) => {
          if (value !== "")
            return (
              <li className="list-inline-item" key={i}>
                <a href="">{value}</a>
              </li>
            );
        })
    );
  }

  render() {
    const { id, slug } = this.props.match.params;
    return (
      <React.Fragment>
        {id && id !== "tv-display" && (
          <div className="breadCrums d-print-none sticky-top">
            <div className="pl-5 pr-4">
              <div className="row">
                <div className="col-12">
                  {/* <p className="text-left">Configuration</p> */}
                  <ol className="list-inline text-left">
                    <li className="list-inline-item">
                      <a href="">Home</a>
                    </li>
                    {this.creumList()}
                  </ol>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default BreadCrums;
